module.exports = __webpack_public_path__ + "img/Remote-access2_scaled.5fe2bb0a.jpg";